import { useState, useEffect, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useAPI } from 'src/services/api';
import Spinner from 'src/components/Spinner';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFViewer = ({ src = '' }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);
  const containerRef = useRef(null);
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function onPageLoadSuccess({ width }) {
    const containerWidth = containerRef.current
      ? containerRef.current.getBoundingClientRect().width
      : 0;
    if (width > containerWidth) {
      setScale(containerWidth / width);
    }
  }

  const api = useAPI();

  useEffect(() => {
    const fetchPDF = async () => {
      try {
        setIsLoading(true);
        const response = await api.get(`posts/download/${src}`, {
          responseType: 'blob',
        });

        setFile(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error occurred while downloading the file:', error);
      }
    };
    fetchPDF();
  }, []);

  // Navigation functions
  const goToPrevPage = () => setPageNumber(pageNumber - 1);
  const goToNextPage = () => setPageNumber(pageNumber + 1);

  return (
    <div
      ref={containerRef}
      className="w-full h-full flex flex-col items-center justify-center rounded-lg object-contain object-center text-white"
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className="pdf-page-container">
            <Document file={file} onLoadSuccess={onDocumentLoadSuccess} onError={console.error}>
              <Page
                pageNumber={pageNumber}
                renderTextLayer={false}
                onLoadSuccess={onPageLoadSuccess}
                renderAnnotationLayer={false}
                scale={scale}
              />
            </Document>
          </div>
          <div className="flex items-center justify-center gap-4  w-full p-3">
            <button
              className={`px-4 py-2 text-white rounded-lg transition duration-300 ease-in-out ${
                pageNumber <= 1
                  ? 'bg-gray-300 cursor-default'
                  : 'bg-blue-600 hover:bg-blue-700 bg-opacity-70 backdrop-blur-lg'
              }`}
              style={{ boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.2)' }}
              onClick={goToPrevPage}
              disabled={pageNumber <= 1}
            >
              Prev
            </button>
            <p>
              Page {pageNumber} of {numPages}
            </p>
            <button
              className={`px-4 py-2 text-white rounded-lg transition duration-300 ease-in-out ${
                pageNumber >= numPages
                  ? 'bg-gray-300 cursor-default'
                  : 'bg-blue-600 hover:bg-blue-700 bg-opacity-70 backdrop-blur-lg'
              }`}
              style={{ boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.2)' }}
              onClick={goToNextPage}
              disabled={pageNumber >= numPages}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default PDFViewer;
